export default "__VITE_ASSET__DVCd2gHV__"